export default {
  header: '"Source Sans Pro", sans-serif',
  // main: '"Greek", "Noto Sans", sans-serif',
  main: '"Noto Sans", sans-serif'
};



// WEBPACK FOOTER //
// ./src/styles/fonts.js